/**
 * Wholesale Collection Card Price Sync v29
 *
 * Background modal triggering to force WSAIO price injection on page load.
 * Opens ALL modals in parallel for faster sync.
 */

(function () {
  'use strict';

  var DEBUG = false;

  function log() {
    if (DEBUG && console && console.log) {
      console.log.apply(console, ['[WSAIO-Sync]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  function triggerModalsInBackground() {
    log('v29 - Parallel modal triggering');

    var triggers = document.querySelectorAll('[data-atc-modal-trigger]');
    log('Found', triggers.length, 'modal triggers');

    if (triggers.length === 0) return;

    // Add CSS to make modals invisible during sync
    var style = document.createElement('style');
    style.id = 'wsaio-sync-hide';
    style.textContent = '.collections__atc-modal:not(.hidden) { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; position: fixed !important; top: -9999px !important; }';
    document.head.appendChild(style);

    // Click ALL triggers at once to open all modals
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].click();
    }

    // Wait for WSAIO to process all, then close all modals
    setTimeout(function() {
      var modals = document.querySelectorAll('product-card-atc-modal.collections__atc-modal');
      for (var j = 0; j < modals.length; j++) {
        modals[j].classList.add('hidden');
      }

      // Remove hiding CSS
      var hideStyle = document.getElementById('wsaio-sync-hide');
      if (hideStyle) hideStyle.remove();

      log('Background sync complete');
    }, 400);
  }

  // Wait for WSAIO to be ready, then trigger background sync
  function waitForWSAIO() {
    if (typeof WSAIO !== 'undefined') {
      log('WSAIO found, starting background sync');
      triggerModalsInBackground();
    } else {
      log('Waiting for WSAIO...');
      setTimeout(waitForWSAIO, 200);
    }
  }

  // Run after page is ready
  setTimeout(function() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForWSAIO);
    } else {
      waitForWSAIO();
    }
  }, 300);
})();
